export default __webpack_public_path__ + "static/media/vuetify.dbf3c8cf.png";